import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Navbar } from '@/components/generals/navbar'
import { Footer } from '@/components/generals/footer'
import { SiteMotion } from '@/components/generals/site-motion'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only rounded-full bg-butter px-5 py-3 font-heading text-lg text-plum focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[60]'
            >
                Skip to content
            </a>

            <Navbar />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <Footer />

            <SiteMotion />
        </div>
    )
}
